import { useGetMe } from "../index";

function useCurrentFundingApplication() {
  const { data: me, refetch } = useGetMe();
  const { fundingApplications } = me || {};
  const currentApplication = fundingApplications?.[0];
  const fundingApplicationId = currentApplication?.id;
  const isFunded = !!currentApplication?.fundedAt;

  return { currentApplication, fundingApplicationId, refetch, isFunded };
}

export default useCurrentFundingApplication;